module.exports = __webpack_public_path__ + "img/zenith_bank.2368d2a7.png";